<template>
  <el-popover title="佣金设置" placement="bottom-start" trigger="click" width="250" v-model="visible">
    <ul>
      <li v-for="(item,index) in specForm.commissionQuotaList" :key="index" class="flex p-v-5">
        <div style="width: 80px" class="flex-s-0">{{ item.name }}</div>
        <el-input size="small" v-money v-model="item.value" style="width: 100%"/>
      </li>
    </ul>
    <el-input size="small" slot="reference" readonly
              :value="getcommissionPrice"></el-input>
    <div style="text-align: right; margin: 0" class="m-t-10">
      <el-button size="mini" type="text" @click="visible = false" v-show="false">取消</el-button>
      <el-button type="primary" size="mini" @click="visible = false">确定</el-button>
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'CommissonSetting',
  props: {
    specForm: {
      type: Object
    }
  },
  computed: {
    getcommissionPrice () {
      let price = 0
      if (this.specForm.commissionQuotaList && this.specForm.commissionQuotaList.length) {
        for (let i = 0; i < this.specForm.commissionQuotaList.length; i++) {
          let commissionTypeItem = this.specForm.commissionQuotaList[i]
          price += parseFloat(commissionTypeItem.value || 0)
        }
      }
      this.specForm.commissionPrice = (price || 0).toFixed(2)
      return this.specForm.commissionPrice
    }
  },
  data () {
    return {
      visible: false
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onFousInput (e) {
      let text = e.target.value
      if (text && parseInt(text) <= 0) {
        e.target.value = ''
      }
    },
    onBlurInput (e) {
      console.log(e.target.value)
      let text = e.target.value
      if (!text || parseInt(text) <= 0) {
        e.target.value = '0.00'
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/product/product/part/spec/many/CommissonSetting.vue